import React from 'react';
import PropTypes from 'prop-types';

const UserAddPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M7.998 12a8 8 0 1 1 14.292 4.942 8.499 8.499 0 0 0-3.879 2.688c-.762.24-1.572.37-2.413.37a8 8 0 0 1-8-8zM18 25a7 7 0 1 1 14 0 7 7 0 0 1-14 0zm2 .495a.5.5 0 0 0 .51.505H24v3.49c0 .282.226.51.505.51h.991a.5.5 0 0 0 .504-.51V26h3.491a.507.507 0 0 0 .509-.505v-.991a.5.5 0 0 0-.509-.504H26v-3.49a.507.507 0 0 0-.504-.51h-.991a.5.5 0 0 0-.505.51V24h-3.49a.507.507 0 0 0-.51.504v.991zM4.139 26.586c-.093.455-.061.413-.061.413A.91.91 0 0 0 4.998 28h12.047a8.477 8.477 0 0 1-.545-3c0-.884.135-1.736.385-2.537a10.45 10.45 0 0 1-6.996-1.921c-3.022 1.201-5.19 3.323-5.75 6.044z"
    />
  );
};

UserAddPath.propTypes = {
  fill: PropTypes.string,
};

export default UserAddPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/user/user-add.jsx